import { all } from 'redux-saga/effects'
import layoutWatcher from './layout'
import userWatcher from './user'

export default function* watcherSaga() {
  yield all([layoutWatcher(), userWatcher()])
}
